// removed by extract-text-webpack-plugin
module.exports = {"root":"qempo_WaysToPay_root-OteAghc","dualWrap":"qempo_WaysToPay_dualWrap-1MS05gp","leftWrap":"qempo_WaysToPay_leftWrap-i4U0ssb","contentWrap":"qempo_WaysToPay_contentWrap-mzgBkz6","column":"qempo_WaysToPay_column-2SgDuog","imageWrap":"qempo_WaysToPay_imageWrap-7zIfZVX","rightWrap":"qempo_WaysToPay_rightWrap-2Qo5MWI","buttonBuyNow":"qempo_WaysToPay_buttonBuyNow-2-6BQ9Z"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/WaysToPay/WaysToPay.scss
// module id = 2283
// module chunks = 0